import { render, staticRenderFns } from "./RealTimeTaskPage.vue?vue&type=template&id=e9793908&scoped=true&"
import script from "./RealTimeTaskPage.vue?vue&type=script&lang=js&"
export * from "./RealTimeTaskPage.vue?vue&type=script&lang=js&"
import style0 from "./RealTimeTaskPage.vue?vue&type=style&index=0&id=e9793908&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9793908",
  null
  
)

export default component.exports